import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterReviewStatus } from '@/api/model/interfaces';

export default class RegisterReviewStatusOdata extends OdataManager<RegisterReviewStatus> {}
